import initialState from './initialState';
import { reducer as loadEditorCollectionsReducer } from './loadEditorCollections';
import { reducer as loadPagesReducer } from './loadPages';
import { reducer as loadProjectAssetsReducer } from './loadProjectAssets';
import { reducer as loadSnippetsReducer } from './loadSnippets';
import { reducer as loadEventsReducer } from './loadEvents';
import { reducer as loadInstalledPluginReducer } from './loadInstalledPlugin';
import { reducer as updateLatestPublishVersionReducer } from './updateLatestPublishVersion';
import { reducer as addLastAccessReducer } from './addLastAccess';
import { reducer as publishVibeCodeReducer } from './publishVibeCode';

const reducers = [
  loadEditorCollectionsReducer,
  loadPagesReducer,
  loadProjectAssetsReducer,
  loadSnippetsReducer,
  loadEventsReducer,
  loadInstalledPluginReducer,
  updateLatestPublishVersionReducer,
  addLastAccessReducer,
  publishVibeCodeReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
